import * as Common from '@/tenant/common';

export class CommodityAnalyseReportQuery extends Common.Query {
    constructor(){
        super("CommodityAnalyseReportQuery", null);
    }
    public templateId:number=0;
    public closingDateFrom: Date = null;
    public closingDateTo: Date = null;
    public segment: Common.Segment = null;
    public commodityCategory: Common.Category = null;
    public onExcelExport:boolean = false;           
}

export class CommodityAnalyseReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='CommodityAnalyseReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}